import { render, staticRenderFns } from "./TvDetail.vue?vue&type=template&id=8e6bebe8&scoped=true&"
import script from "./TvDetail.vue?vue&type=script&lang=js&"
export * from "./TvDetail.vue?vue&type=script&lang=js&"
import style0 from "./TvDetail.vue?vue&type=style&index=0&id=8e6bebe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6bebe8",
  null
  
)

export default component.exports